/**
 * Returns the image of defined tsps. If no image is found, a placeholder image is returned.
 * @param {*} tspKey key of tsp
 * @param {*} width width of image
 * @param {*} height height of image
 * @returns
 */

export enum tspKeyEnum {
    OUR_GREEN_CAR = 'OurGreenCar',
    EXAMPLE = 'ex',
    EC2B_BIKE = 'eb',
    VASTRAFIK = 'vt',
    SKANETRAFIKEN = 'sktr',
    MABI_CARSHARE = 'macs',
    MOVE_ABOUT = 'moab',
    MABI_RENTAL_CAR = 'macr',
    VOI_ELECTRIC_SCOOTER = 'voi',
    CORIDE = 'crd',
    KINTO_SHARE = 'kint',
    SPORTSON = 'sprt',
}
export type TspKeyType = tspKeyEnum | string;
